module.exports = __webpack_public_path__ + "img/94ne.efcb54e2.svg";